document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('[data-product-stock-etd]');
  if (!wrapper) return;

  const jsonEl = wrapper.querySelector('[data-variant-stock-etd-json]');
  const display = wrapper.querySelector('[data-stock-status-display]');
  if (!jsonEl || !display) return;

  const variantData = JSON.parse(jsonEl.textContent);

  // Dawn despacha este evento custom en el elemento variant-selects o variant-radios
  document.addEventListener('variant:changed', (event) => {
    const variantId = String(event.detail?.variant?.id);
    const data = variantData[variantId];
    if (!data) return;

    updateDisplay(data);
  });

  // También escuchamos el evento nativo de Dawn (por si acaso)
  document.addEventListener('change', (event) => {
    const variantInput = event.target.closest('[name="id"]');
    if (!variantInput) return;

    const variantId = variantInput.value;
    const data = variantData[variantId];
    if (!data) return;

    updateDisplay(data);
  });

  function updateDisplay({ availability, etd_message }) {
    const classMap = {
      s: 'stock-available',
      p: 'stock-available',
      n: 'stock-unavailable',
    };
    const cls = classMap[String(availability).toLowerCase()] ?? 'stock-unknown';

    display.innerHTML = `<span class="${cls}"></span>`;
    display.append(etd_message ?? '');
  }
});